export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/Block3-98e73f79b617d46ed9eaee6e18722efb.png";